// import memoized from 'nano-memoize';

export default function percentage(val) {
  if (val === '') {
    return '-';
  }
  if (Number.isNaN(val)) {
    return '-';
  }
  if (!Number.isFinite(val)) {
    return '-';
  }
  const f = val.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${f}%`;
}

// export default memoized(percentage, {
//   maxArgs: 1,
// });
